export function addCurrent(patrimonymaterial) {
    return {
        type: 'ADD_CURRENT',
        patrimonymaterial,
    }
}
